import {
    getBaseItemDisplay,
    updateDisplayName,
    topDisplayClassify,
    delDisplayClassify,
    addBaseItemDisplay, 
    moveDisplayClassify,
    addItemDisplayCode,
} from '@api/base/index.js';

//获取展架列表
export function queryBaseItemDisplay ( param = {} ) {
    const params = {
        parentId: '0',
        ...param,
    }
    return getBaseItemDisplay(params).then(res => {
        if (res.result === 1 && res.data) {
            if (res.result === 1 && res.data) {
                return res.data
            }
            return [];
        }
    })
}
//修改展架名
export function eidtDisplayName(data) {
    return updateDisplayName(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}
// 删除展架
export function deleteDisplayClassify(data) {
    return delDisplayClassify(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}

// 置顶展架
export function setTopDisplayClassify(data) {
    return topDisplayClassify(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}

// 新增分类
export function addBaseItemDisplayClassify(data) {
    return addBaseItemDisplay(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}


// 移动展架
export function moveToDisplayClassify(data) {
    return moveDisplayClassify(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}

// 添加商品展架
export function saveItemDisplayCode(data) {
    return addItemDisplayCode(data).then(res => {
        if (res.result === 1 ) {
            return true;
        }
        return false;
    })
}



